import { SvgCallToAction } from '@loomhq/lens';
import React from 'react';
import { connect } from 'react-redux';

import {
  endCTAFlow,
  endThumbnailFlow,
  endVideoSettingsFlow,
  startCTAFlow,
} from 'actions/editor';
import { requestVideoPlayerLeaveFullScreen } from 'actions/videoPlayer';
import { toggleViewerInsightsUI } from 'actions/viewerInsights';
import {
  ADD_CALL_TO_ACTION_UPGRADE_BUTTON_CLICKED,
  ADD_CUSTOM_VIDEO_CTA_CLICKED,
  SHARE_PAGE_EDITOR_FAB_PRO_UPSELL,
} from 'constants/events';
import { PLANS_AND_BILLING } from 'constants/routes';
import { CALL_TO_ACTION_UPGRADE_MESSAGE } from 'constants/upgradeMessages';
import * as analytics from 'utilities/analytics';
import { isMobile } from 'utilities/device';

import { hasScope } from 'selectors/scopes';
import { selectUserCanEditVideo } from 'selectors/shareVideo';
import { selectIsActive } from 'selectors/viewerInsights';

import CollapsibleSideButton from '../collapsible-side-button';
import { VIDEO_CTA_ACCESS } from '../../../../../shared/constants/scopes';

import UpgradeTooltip from 'components/upgrade-tooltip';

class AddVideoCtaButton extends React.Component {
  render() {
    const {
      ctaEnabled,
      disabled,
      hasCTAScope,
      isCollapsed,
      userCanEditVideo,
      workspaces,
    } = this.props;

    const selectedWorkspace = workspaces.find(ws => ws.isSelected);

    // Show if url arg is there or if the user has already enabled it
    let button = null;

    if (hasCTAScope) {
      button = (
        <CollapsibleSideButton
          icon={<SvgCallToAction />}
          isCollapsed={isCollapsed}
          isDisabled={disabled}
          onClick={this.handleClick}
        >
          {ctaEnabled ? 'Edit call-to-action' : 'Call-to-action'}
        </CollapsibleSideButton>
      );
    } else {
      button = (
        <UpgradeTooltip
          title="Call-to-action"
          placement="leftCenter"
          message={CALL_TO_ACTION_UPGRADE_MESSAGE}
        >
          <div
            tabIndex="0"
            role="button"
            className="disabledButtonWrapper"
            onClick={() => {
              analytics.track(
                ADD_CALL_TO_ACTION_UPGRADE_BUTTON_CLICKED,
                {
                  userId: window.loomSSRUser.id,
                  userEmail: window.loomSSRUser.email,
                  workspaceId: selectedWorkspace.id,
                },
                () => {
                  window.location.href = PLANS_AND_BILLING;
                }
              );
            }}
          >
            <CollapsibleSideButton
              icon={<SvgCallToAction />}
              isCollapsed={isCollapsed}
              isDisabled
            >
              Call-to-Action
            </CollapsibleSideButton>
          </div>
        </UpgradeTooltip>
      );
    }

    return userCanEditVideo && !isMobile && button;
  }

  handleUpgradeUpsell = () => {
    analytics.track(
      SHARE_PAGE_EDITOR_FAB_PRO_UPSELL,
      {
        fab_type: 'cta',
      },
      () => {
        window.location.href = '/account-settings?showUpgrade=true#billing';
      }
    );
  };

  handleClick = () => {
    const {
      areVideoCtaSettingsOpen,
      areVideoSettingsOpen,
      areViewerInsightsOpen,
      areThumbnailSettingsOpen,
      endCTAFlow,
      endVideoSettingsFlow,
      endThumbnailFlow,
      isVideoPlayerFullScreen,
      requestVideoPlayerLeaveFullScreen,
      startCTAFlow,
      toggleViewerInsightsUI,
    } = this.props;

    if (areVideoCtaSettingsOpen) {
      endCTAFlow();

      return;
    }

    analytics.track(ADD_CUSTOM_VIDEO_CTA_CLICKED);

    if (areViewerInsightsOpen) {
      toggleViewerInsightsUI();
    }

    if (areVideoSettingsOpen) {
      endVideoSettingsFlow();
    }

    if (areThumbnailSettingsOpen) {
      endThumbnailFlow();
    }

    // we only request leaving full screen if already full screen,
    // otherwise we queue up the request to leave full screen
    if (isVideoPlayerFullScreen) {
      requestVideoPlayerLeaveFullScreen();
    }

    startCTAFlow();
  };
}

const mapStateToProps = state => {
  const { cta_enabled: ctaEnabled } = state.share_video;

  return {
    areVideoCtaSettingsOpen: state.editor?.cta_flow,
    areVideoSettingsOpen: state.editor?.video_settings_flow,
    areViewerInsightsOpen: selectIsActive(state),
    areThumbnailSettingsOpen: state.editor?.thumbnail_flow,
    ctaEnabled,
    hasCTAScope: hasScope(state, VIDEO_CTA_ACCESS),
    isVideoPlayerFullScreen: state.video_player?.full_screen,
    userCanEditVideo: selectUserCanEditVideo(state),
    workspaces: state.workspace?.workspaces,
  };
};

const mapDispatchToProps = dispatch => ({
  endVideoSettingsFlow: () => dispatch(endVideoSettingsFlow()),
  requestVideoPlayerLeaveFullScreen: () =>
    dispatch(requestVideoPlayerLeaveFullScreen()),
  startCTAFlow: () => dispatch(startCTAFlow()),
  endCTAFlow: () => dispatch(endCTAFlow()),
  toggleViewerInsightsUI: () => dispatch(toggleViewerInsightsUI()),
  endThumbnailFlow: () => dispatch(endThumbnailFlow()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddVideoCtaButton);
